<script>
import BasePopup from '../../BasePopup.vue';
import CheckList from '../../checlkist/CheckList.vue';

export default {
  name: 'TaskViewChecklistPopup',
  components: { BasePopup, CheckList },
  data() {
    return {
      checklist: [],
    };
  },
  methods: {
    async submit(boolean) {
      if (boolean) {
        this.$emit('submit', this.checklist);
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<template lang="pug">
BasePopup(@close="submit(false)" :zIndex="9000")
  .checklist-popup
    .checklist-header Изменить чек-лист
    .options
      .checklist-container
        CheckList.item(:value="checklist" :id="0" :editable="true")
    .buttons
      Btn(@click="submit(true)" transparent round narrow) Применить
      Btn(@click="checklist = []" transparent round narrow) Сбросить
</template>

<style scoped lang="scss">
.checklist-header {
  display: flex;
  color: rgba(35, 34, 38, 1);
  font-family: Geometria, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.options {
  padding-top: 41px;
  padding-bottom: 35px;
  display: flex;
  gap: 50px;
}

.checklist-container {
  display: flex;
  flex-direction: column;
  width: 800px;
  gap: 15px;
  align-items: flex-start;
}

.buttons {
  display: flex;
  gap: 30px;
}

.item {
  width: 90%;
}
</style>
